module.exports = __webpack_public_path__ + "static/media/10_FR.66189e89.mp3";